"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeUnsupportedUnicode = escapeUnsupportedUnicode;
function escapeUnsupportedUnicode(tex) {
    return tex
        .replace(/€/g, "\\unicode{0x20AC}")
        .replace(/₹/g, "\\unicode{0x20B9}")
        .replace(/₼/g, "\\unicode{0x20BC}")
        .replace(/ə/g, "\\unicode{0x0259}")
        .replace(/ɛ/g, "\\unicode{0x025B}")
        .replace(/Ɛ/g, "\\unicode{0x0190}")
        .replace(/₸/g, "\\unicode{0x20B8}")
        .replace(/₾/g, "\\unicode{0x20BE}")
        .replace(/₪/g, "\\unicode{0x20AA}");
}
